import { ao3Assets } from "@/mocks/ao3Home";
import { ao3AbsoluteUrl } from "./ao3SeoConfig";

const ao3FaqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: [
    {
      "@type": "Question",
      name: "What is AO3 Reader?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "AO3 Reader is a companion app for reading works published on the Archive of Our Own (AO3). It is made and maintained by fans and is not officially affiliated with the Organization for Transformative Works.",
      },
    },
    {
      "@type": "Question",
      name: "Is AO3 Reader really free?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Yes. The app is free to download and use on Android, iOS, HarmonyOS and Windows. There is no paywall between you and the stories you want to read.",
      },
    },
    {
      "@type": "Question",
      name: "How do I fix the AO3.CUBEART.CLUB HOST ERROR?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "That message appears when a mirror or third-party host is temporarily unreachable. Update to the latest build, clear the in-app cache, then use the official download buttons on this page to reinstall a working client.",
      },
    },
    {
      "@type": "Question",
      name: "Which platforms are supported?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "Android, iOS, HarmonyOS and Windows. Tap any download button on this page and pick the build for your device.",
      },
    },
    {
      "@type": "Question",
      name: "Where is the AO3链接入口?",
      acceptedAnswer: {
        "@type": "Answer",
        text: "The AO3链接入口 is the direct entry into AO3 from inside the app. Open the app and tap the compass icon in the bottom bar to land straight on the AO3 feed.",
      },
    },
  ],
};

const homeSchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "AO3 Reader",
    url: ao3AbsoluteUrl("/"),
    inLanguage: ["en", "zh-CN"],
    image: ao3Assets.heroBackground,
    publisher: {
      "@type": "Organization",
      name: "AO3 Reader",
      logo: {
        "@type": "ImageObject",
        url: ao3Assets.logo,
      },
    },
  },
  {
    "@context": "https://schema.org",
    "@type": "SoftwareApplication",
    name: "AO3 Reader",
    applicationCategory: "BookApplication",
    operatingSystem: "Android, iOS, HarmonyOS, Windows",
    url: ao3AbsoluteUrl("/"),
    image: ao3Assets.heroBackground,
    description:
      "AO3 Reader is a fan-made reading app for the Archive of Our Own, available on Android, iOS, HarmonyOS and Windows.",
  },
  ao3FaqSchema,
];

const reportSchema = [
  {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "投诉举报 - AO3 Reader",
    url: ao3AbsoluteUrl("/report"),
    inLanguage: "zh-CN",
    description:
      "AO3阅读器投诉举报通道，用于反馈产品侵权、虚假官网、欺诈交易等问题。",
    isPartOf: {
      "@type": "WebSite",
      name: "AO3 Reader",
      url: ao3AbsoluteUrl("/"),
    },
  },
];

export function ao3SchemaForRoute(pathname: string): object[] {
  if (pathname === "/") {
    return homeSchema;
  }
  if (pathname === "/report") {
    return reportSchema;
  }
  return [];
}